import {
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { T } from '@tolgee/react';
import { Avatar } from 'antd';
import { useGlobalContext } from '../../../global-context/GlobalContext';
import SwitchUserRole from '../../SwitchUserRole';

export const CompanyAvatar = () => {
  const userInfo = useGlobalContext(c => c.auth.userInfo);

  const fullName = userInfo
    ? userInfo?.firstName + ' ' + userInfo?.familyName
    : '';
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Avatar
        style={{
          backgroundColor: '#fefaf7',
          color: '#000',
          marginLeft: '1rem',
        }}
        size='small'
      >
        {userInfo && userInfo?.firstName[0] + userInfo?.familyName[0]}
      </Avatar>
      <span
        className='userName'
        style={{
          marginLeft: '10px',
          lineHeight: '13px',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <div style={{ fontSize: '11px' }}>{fullName}</div>
        <div style={{ fontSize: '9px', color: 'gray' }}>
          {userInfo && userInfo.email}
        </div>
      </span>
    </div>
  );
};

export const SidebarSettingMenu = () => {
  const roles = useGlobalContext(c => c.auth.userRoles);
  const sidebarMenus: {
    key: string;
    label: JSX.Element;
    style?: React.CSSProperties;
  }[] = [{ key: '10.1', label: <CompanyAvatar />, style: { padding: '0 0' } }];

  if (roles.length > 1) {
    sidebarMenus.push({
      key: '10.2',
      label: (
        <span className='user_links'>
          <SwitchUserRole />
        </span>
      ),
    });
  }

  sidebarMenus.push({
    key: 'logout',
    label: (
      <span className='user_links'>
        <LogoutOutlined style={{ marginRight: '0.8rem' }} />
        <T keyName='sign-out' />
      </span>
    ),
  });

  return sidebarMenus;
};
export const sidebarBottomMenu = () => {
  const settingMenu = SidebarSettingMenu();

  return [
    {
      label: <T keyName='nav-user-settings' />,
      key: '10',
      icon: <UserOutlined />,
      children: settingMenu,
    },
  ];
};
